import React from 'react';
import PropTypes from 'prop-types';
import Button from '@concur/nui-widgets/Button';
import classnamesBind from 'classnames/bind';
import { withFormatter } from '@concur/nui-intl-runtime';
import { withErrorBoundary, compose } from '@concur/core-ui-shell';
import Logo from '../Logo/Logo';
import styles from './AppMiniHeader.css';
import clearLocalizationMode from '../utils/clearLocalizationMode';
import { clearSideNavState } from '../utils/sideNavStateUtils';
import { clearSessionStorage } from '../utils/sessionStorageUtils';

const CSS_BLOCK = 'sapcnqr-app-mini-header';

const MiniHeader = ({
    formatter,
    isLoggedIn,
    isOpusUser,
    configOptions,
    brandingLogoData,
    brandingLogoUrl,
    companyName,
    oshCacheIdentifier,
    /* eslint-disable no-unused-vars */
    logoutUser,
    isGov,
    /* eslint-enable no-unused-vars */
}) => {
    const classnames = classnamesBind.bind(styles);

    const baseClasses = classnames(CSS_BLOCK);

    const homeIconClasses = classnames(
        `${CSS_BLOCK}__home-icon`,
    );

    return (
        <div className={baseClasses} data-test="mini-header">
            <span className={classnames(`${CSS_BLOCK}__container`)}>
                <Logo
                    styles={styles}
                    cssBlock={CSS_BLOCK}
                    className={homeIconClasses}
                    isOpusUser={isOpusUser}
                    configOptions={configOptions}
                    brandingLogoData={brandingLogoData}
                    brandingLogoUrl={brandingLogoUrl}
                    companyName={companyName}
                />
            </span>
            {isLoggedIn && (
                <Button
                    data-test="app-mini-header-signout-link"
                    onClick={() => {
                        clearLocalizationMode();
                        clearSideNavState();
                        clearSessionStorage(oshCacheIdentifier);
                        window.location.href = '/errors/loggedout.asp';
                    }}
                    type="link"
                    className={classnames(`${CSS_BLOCK}__button--signout`)}
                >
                    {formatter.formattedMessage({ id: 'CoreUI.signOut' })}
                </Button>
            )}
        </div>
    );
};

MiniHeader.displayName = 'MiniHeader';

MiniHeader.cssBlock = CSS_BLOCK;

MiniHeader.propTypes = {
    isLoggedIn: PropTypes.bool,
    isGov: PropTypes.bool,
    logoutUser: PropTypes.func,
    isOpusUser: PropTypes.bool,
    brandingLogoData: PropTypes.string,
    brandingLogoUrl: PropTypes.string,
    companyName: PropTypes.string,
    configOptions: PropTypes.object,
    oshCacheIdentifier: PropTypes.string,
};

export default compose(
    withFormatter,
    withErrorBoundary,
)(MiniHeader);
